import { IUcApiRequest, IUcApiResponse, IUcRequest } from "../../shared/interfaces";
import { HttpUtils } from "../../shared/utils/httpUtils";

// const mockUcApiResponse: IUcApiResponse = {
//   consultaUcResponse: {
//     resumoDoRetorno: "Consulta realizada com sucesso.",
//     mensagemDeRetorno: "UC encontrada.",
//     tipoPessoa: ClientTypeEnum.COMPANY,
//     ucAntiga: 123456,
//     ucANEEL: 654321,
//     numeroPredial: "101",
//     primeiroNomeDaMae: "Maria",
//     indicCoexistente: true,
//   },
// };

export class UcService {
  public static async searchUc(
    data: IUcApiRequest,
    captchaToken: string
  ): Promise<IUcApiResponse> {
    const response = await HttpUtils.performPost<{
      captchaToken: string;
      consultaUcRequest: IUcRequest;
    }>("/xuwweb/api/xuc/search-uc", { ...data, captchaToken });

    console.log("UC Service Response data:", response);
    return response;
  }
}
